import { api } from "@/frontend/services/api";
import type {
  PermissionResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
  PaginationResponseDTO,
} from "@/shared/dto";

const BASE_URL = "/permissions/private";

export const permissionsService = {
  // Obtener permisos NO asignados a un rol (roleId debe venir en filters)
  getNotAssignedToRolePaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<PaginationResponseDTO<PermissionResponseDTO>>>(
      BASE_URL,
      params
    );
  },
  // Obtener permisos asignados a un rol (roleId debe venir en filters)
  getByRoleIdPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<PaginationResponseDTO<PermissionResponseDTO>>>(
      `${BASE_URL}/by-role`,
      params
    );
  },
};
